import * as React from 'react';
import './searchInput.scss';
import { Search } from 'rcd-cpp-ui/ui/icon';
import { cn } from '../../utils';

interface Props {
  onClick?: Function;
}

export const SearchInput = ({ onClick}: Props) => {
  return (
    <div
      className='input-group-append'
      onClick={() => {
        !!onClick ? onClick() : null;
      }}
    >
      <div className="input-group-text">
        <Search />
        <div></div>
      </div>
    </div>
  );
};
